/*!
=========================================================
* Argon Design System React - v1.1.0
=========================================================
* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React from "react";
// nodejs library that concatenates classes
import classnames from "classnames";

// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardImg,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";

// core components

// index page sections
import Download from "../IndexSections/Download.js";
import logo from "../brandmark-design.png";
import Typical from 'react-typical'
import { fontWeight } from "styled-system";

import ethLogo from '../examples/ethereum-cash.svg'
import discussion from "../examples/Discussion-rafiki.svg"
import voting from "../examples/Voting-amico.svg"
import circle from "../examples/Circles-pana.svg"
import SimpleFooter from "./components/Footers/SimpleFooter.js";

class Landing extends React.Component {
  state = {};
  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }
  render() {
    return (
      <>
        <main ref="main" style={{ backgroundColor: 'white', height: '95vh' }}>
          {/* <main ref="main" style={{ backgroundImage: 'linear-gradient(to right,#867FD7,#6EA59A)', height: '95vh' }}> */}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250" >
              <div className="shape shape-style-1 shape-default">
                {/* <div className = "container">
                  <img src={logo} alt="RoundTable-logo" width="1000" style={{marginTop:100 }} />
                </div> */}
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="10">
                      <h1 className="display-3 text-black" style={{
                        background: '-webkit-linear-gradient(top right, #867fd7, #6EA59A)',
                        webkitBackgroundClip: 'text',
                        webkitTextFillColor: 'transparent',
                        // fontWeight:'bold',
                        // fontFamily:'helvetica',
                        // fontSize: '60px'
                      }}>
                        <br></br>
                        {/* <b>
                          Reimagine voting, governance, <br></br>decision making...
                        </b> */}
                        <Typical
                          steps={['Reimagine', 1000, 'Reimagine Voting', 1000, 'Reimagine Governance', 1000, 'Reimagine Decision-Making', 1000, 'Reimagine with RoundTable', 1000]}
                          loop={2}
                          wrapper="p"
                        />
                      </h1>
                      {/* <p className="lead text-white">
                      </p> */}
                      <br></br>
                      {/* <div className="btn-wrapper">
                        <Button style={{ marginRight: 20 }}
                          className="btn-outline-light"
                          onClick={reloadPage}
                        >
                          <span className="btn-inner--text">Browse Circles</span>
                        </Button>
                        <Button
                          className="btn-outline-light"
                          // color="primary"
                          onClick={refreshPage}
                        >
                          <span className="btn-inner--text">Create a Circle</span>
                        </Button>
                      </div> */}
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              {/* <div className="separator separator-bottom separator-skew">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                  version="1.1"
                  viewBox="0 0 2560 100"
                  x="0"
                  y="0"
                >
                  <polygon
                    className="fill-white"
                    points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div> */}
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  {/* <Row className="row-grid"> */}
                  <Row>
                    <Col lg="4">
                      <Card className="card-lift--hover shadow border-0" style={{ backgroundColor: '#e6e8fa', width: '500px', borderRadius: "10px" }}>
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-primary rounded-circle mb-4">
                            <i className="ni ni-check-bold" />
                          </div>
                          <h6 className="text-uppercase" style={{ color: "#867fd7" }}>
                            {/* <h6 style={{textColor:"#867fd7"}}> */}
                            What is a Circle?
                          </h6>
                          <p className="description mt-3">
                            By joining a Circle, you can make decisions with the other members of the Circle through a democratic voting process.
                          </p>
                          <div>
                            {/* <Badge color="primary" pill className="mr-1">
                              design
                            </Badge>
                            <Badge color="primary" pill className="mr-1">
                              system
                            </Badge>
                            <Badge color="primary" pill className="mr-1">
                              creative
                            </Badge> */}
                          </div>
                          {/* Redirect to About Page */}
                          <Button
                            className="mt-4"
                            style={{
                              backgroundColor: "#867fd7", hover: {
                                backgroundColor: '#ffffff'
                              }
                            }}
                            onClick={aboutPage}
                          >
                            Learn more
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col>
                      <img src={discussion} width="500" height="600" style={{ margin: '-150px 0px -50px 150px' }} />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <img src={voting} width="500" height="500" />
                    </Col>
                    <Col>
                      <Card className="card-lift--hover shadow border-0" style={{ backgroundColor: '#e3f5ff', borderRadius: "10px" }}>
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-success rounded-circle mb-4">
                            <i className="ni ni-istanbul" />
                          </div>
                          <h6 className="text-uppercase" style={{ color: "#7698ae" }}>
                            Browse Circles
                          </h6>
                          <p className="description mt-3">
                            See which communities have open circles and the proposals they have launched through RoundTable.
                          </p>
                          <div>
                            {/* <Badge color="success" pill className="mr-1">
                              business
                            </Badge>
                            <Badge color="success" pill className="mr-1">
                              vision
                            </Badge>
                            <Badge color="success" pill className="mr-1">
                              success
                            </Badge> */}
                          </div>
                          {/* <Button
                            className="mt-4"
                            color="success"
                            href="#pablo"
                            onClick={e => e.preventDefault()}
                          >
                            Learn more
                          </Button> */}
                          <Button style={{ marginRight: 20 }}
                            className="mt-4"
                            style={{ backgroundColor: "#7698AE" }}
                            onClick={reloadPage}
                          >
                            <span className="btn-inner--text">See a Walkthrough</span>
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  <Row>

                    <Col lg="4">
                      <Card className="card-lift--hover shadow border-0" style={{ backgroundColor: '#e4f5e7', width: '500px', borderRadius: "10px" }}>
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-warning rounded-circle mb-4">
                            <i className="ni ni-planet" />
                          </div>
                          <h6 className="text-uppercase" style={{ color: "#6EA59A" }}>
                            Create Your Circle
                          </h6>
                          <p className="description mt-3">
                            Create your own Circle in 2 minutes with absolutely no code, and start making decisions with your group!
                          </p>
                          <div>
                            {/* <Badge color="warning" pill className="mr-1">
                              marketing
                            </Badge>
                            <Badge color="warning" pill className="mr-1">
                              product
                            </Badge>
                            <Badge color="warning" pill className="mr-1">
                              launch
                            </Badge> */}
                          </div>
                          {/* <Button
                            className="mt-4"
                            color="warning"
                            href="#pablo"
                            onClick={e => e.preventDefault()}
                          >
                            Learn more
                          </Button> */}
                          <Button
                            className="mt-4"
                            style={{ backgroundColor: "#6EA59A" }}
                            // color="primary"
                            onClick={refreshPage}
                          >
                            <span className="btn-inner--text">See a Walkthrough</span>
                          </Button>

                        </CardBody>
                      </Card>
                    </Col>
                    <Col>
                      <img src={circle} style={{ margin: '-150px 0px 0px 150px' }} width="500" height="500" />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
          <br /> <br /> <br />

          <section className="section" style={{ backgroundColor: "#fcf5f9", width: "95vw", borderRadius: "10px", margin: "auto" }}>
            <br /> <br />
            <Container>
              <Row className="justify-content-center text-center mb-lg">
                <Col lg="8">
                  <div className="d-flex px-3">
                    <div>
                      <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
                        <i className="ni ni-building text-primary" />
                      </div>
                    </div>
                    <div className="pl-4">
                      <h2 className="display-3">Our Solution</h2>
                      <p className="lead text-muted">
                        Vote on anything, anywhere - transparently, safely, and easily.
                      </p>
                      <p className="lead text-muted">
                        Through blockchain technology, groups can create Circles on RoundTable
                        to make decisions, vote, and communicate in a streamlined and secure way.
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="mb-5 mb-lg-0" lg="4" md="6">
                  <Card className="shadow shadow-lg--hover mt-5" style={{ height: '250px', borderRadius: "10px", border: "none" }}>
                    <CardBody>
                      <div className="d-flex px-3">
                        <div>
                          <div className="icon icon-shape bg-gradient-success rounded-circle text-white">
                            <i className="ni ni-satisfied" />
                          </div>
                        </div>
                        <div className="pl-4">
                          <h5 className="title" style={{ color: "#867fd7" }}>
                            Easy, Safe Voting
                          </h5>
                          <p>
                            All voting transactions are stored on an online ledger
                            through blockchain technology, which limits errors and
                            automates decision-making.
                          </p>
                          <a
                            href="/#/about"
                            style={{ color: "#867fd7" }}
                          >
                            Learn more
                          </a>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col className="mb-5 mb-lg-0" lg="4" md="6">
                  <Card className="shadow shadow-lg--hover mt-5" style={{ height: '250px', borderRadius: "10px", border: "none" }}>
                    <CardBody>
                      <div className="d-flex px-3">
                        <div>
                          <div className="icon icon-shape bg-gradient-success rounded-circle text-white">
                            <i className="ni ni-satisfied" />
                          </div>
                        </div>
                        <div className="pl-4">
                          <h5 className="title" style={{ color: "#7698ae" }}>
                            Organization Transparency
                          </h5>
                          <p>
                            By joining the Circle associated with your broader group, you can
                            view any decisions made within the group, as well as the Circles and
                            interests of your peers.
                          </p>
                          <a
                            href="/#/about"
                            style={{ color: "#7698ae" }}
                          >
                            Learn more
                          </a>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col className="mb-5 mb-lg-0" lg="4" md="6">
                  <Card className="shadow shadow-lg--hover mt-5" style={{ height: '250px', borderRadius: "10px", border: "none" }}>
                    <CardBody>
                      <div className="d-flex px-3">
                        <div>
                          <div className="icon icon-shape bg-gradient-warning rounded-circle text-white">
                            <i className="ni ni-active-40" />
                          </div>
                        </div>
                        <div className="pl-4">
                          <h5 className="title" style={{ color: "#6EA59A" }}>
                            Verifiable Security
                          </h5>
                          <p>
                            All transactions made are stored on the Ethereum network,
                            which is decentralized and immutable for all users.
                          </p>
                          <a
                            href="/#/about"
                            style={{ color: "#6EA59A" }}
                          >
                            Learn more
                          </a>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
            <br /> <br />
          </section>
          <br />

          <section className="section section-lg">
            <Container>
              <Row className="row-grid align-items-center">
                <Col className="order-md-2" md="6">
                  <img
                    alt="..."
                    className="img-fluid floating"
                    // src={require("./assets/img/theme/promo-1.png")}
                    src={require("../examples/Online connection-rafiki.svg")}
                  />
                </Col>
                <Col className="order-md-1" md="6">
                  <div className="pr-md-5">
                    <div className="icon icon-lg icon-shape icon-shape-success shadow rounded-circle mb-5">
                      <i className="ni ni-settings-gear-65" />
                    </div>
                    <h3>Who can use RoundTable?</h3>
                    <p>
                      Our mission is to be a general decision-making platform, where
                      anybody, anywhere, can create a Circle and share it with their friends.
                    </p>
                    <p>
                      Potential groups who can use RoundTable include:
                    </p>
                    <div style={{ marginLeft: "30px"}}>
                      <div>
                        <Badge
                          className="badge-circle mr-3"
                          color="primary"
                        >
                          <i className="ni ni-settings-gear-65" />
                        </Badge>
                        <h>Angel investing associations</h>
                      </div>
                      <div>
                        <Badge
                          className="badge-circle mr-3"
                          color="primary"
                        >
                          <i className="ni ni-settings-gear-65" />
                        </Badge>
                        <h>Startups</h>
                      </div>
                      <div>
                        <Badge
                          className="badge-circle mr-3"
                          color="primary"
                        >
                          <i className="ni ni-settings-gear-65" />
                        </Badge>
                        <h>Small and mid-sized businesses</h>
                      </div>
                      <div>
                        <Badge
                          className="badge-circle mr-3"
                          color="primary"
                        >
                          <i className="ni ni-settings-gear-65" />
                        </Badge>
                        <h>Community associations</h>
                      </div>
                      <div>
                        <Badge
                          className="badge-circle mr-3"
                          color="primary"
                        >
                          <i className="ni ni-settings-gear-65" />
                        </Badge>
                        <h>Public companies</h>
                      </div>
                      <div>
                        <Badge
                          className="badge-circle mr-3"
                          color="primary"
                        >
                          <i className="ni ni-settings-gear-65" />
                        </Badge>
                        <h>Charities</h>
                      </div>
                      <div>
                        <Badge
                          className="badge-circle mr-3"
                          color="primary"
                        >
                          <i className="ni ni-settings-gear-65" />
                        </Badge>
                        <h>Social groups</h>
                      </div>
                      <div>
                        <Badge
                          className="badge-circle mr-3"
                          color="primary"
                        >
                          <i className="ni ni-settings-gear-65" />
                        </Badge>
                        <h>And more!</h>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <br />
          {/* <section className="section bg-secondary">
            <Container>
              <Row className="row-grid align-items-center">
                <Col md="6">
                  <Card className="bg-default shadow border-0">
                    <CardImg
                      alt="..."
                      src={require("./assets/img/theme/img-1-1200x1000.jpg")}
                      top
                    />
                    <blockquote className="card-blockquote">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="svg-bg"
                        preserveAspectRatio="none"
                        viewBox="0 0 583 95"
                      >
                        <polygon
                          className="fill-default"
                          points="0,52 583,95 0,95"
                        />
                        <polygon
                          className="fill-default"
                          opacity=".2"
                          points="0,42 583,95 683,0 0,95"
                        />
                      </svg>
                      <h4 className="display-3 font-weight-bold text-white">
                        Design System
                      </h4>
                      <p className="lead text-italic text-white">
                        The Arctic Ocean freezes every winter and much of the
                        sea-ice then thaws every summer, and that process will
                        continue whatever happens.
                      </p>
                    </blockquote>
                  </Card>
                </Col>
                <Col md="6">
                  <div className="pl-md-5">
                    <div className="icon icon-lg icon-shape icon-shape-warning shadow rounded-circle mb-5">
                      <i className="ni ni-settings" />
                    </div>
                    <h3>Our customers</h3>
                    <p className="lead">
                      Don't let your uses guess by attaching tooltips and
                      popoves to any element. Just make sure you enable them
                      first via JavaScript.
                    </p>
                    <p>
                      The kit comes with three pre-built pages to help you get
                      started faster. You can change the text and images and
                      you're good to go.
                    </p>
                    <p>
                      The kit comes with three pre-built pages to help you get
                      started faster. You can change the text and images and
                      you're good to go.
                    </p>
                    <a
                      className="font-weight-bold text-warning mt-5"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      A beautiful UI Kit for impactful websites
                    </a>
                  </div>
                </Col>
              </Row>
            </Container>
          </section> */}
          <section className="section section-lg" style={{ backgroundColor: "rgb(241, 241, 241)", width: "95vw", borderRadius: "10px", margin: "auto" }}>
            <br /> <br />
            <Container>
              <Row className="justify-content-center text-center mb-lg">
                <Col lg="8">
                  <h2 className="display-3">Our Team</h2>
                  <p className="lead text-muted">
                    We are a team of Princeton students and alumni who span a
                    broad range of backgrounds, from serial entrepreneurs to venture analysts
                    to software engineers. Our prior work and keen interest in cryptocurrency,
                    as well as decentralized finance, motivates much of what we do and
                    why we do it today.
                  </p>
                </Col>
              </Row>
              <Row>
                <Col className="mb-5 mb-lg-0" lg="3" md="6">
                  <div className="px-4">
                    {/* <img
                      alt="..."
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={require("./assets/img/theme/annie.jpg")}
                      style={{ width: "200px", height: "200px" }}
                    /> */}
                    <div className="pt-4 text-center">
                      <h5 className="title">
                        <span className="d-block mb-1">Annie Liang</span>
                        <small className="h6 text-muted">Co-Founder</small>
                      </h5>
                    </div>
                  </div>
                </Col>
                <Col className="mb-5 mb-lg-0" lg="3" md="6">
                  <div className="px-4">
                    {/* <img
                      alt="..."
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={require("./assets/img/theme/aster.jpg")}
                      style={{ width: "200px", height: "200px" }}
                    /> */}
                    <div className="pt-4 text-center">
                      <h5 className="title">
                        <span className="d-block mb-1">Aster Zhang</span>
                        <small className="h6 text-muted">Co-Founder</small>
                      </h5>
                    </div>
                  </div>
                </Col>
                <Col className="mb-5 mb-lg-0" lg="3" md="6">
                  <div className="px-4">
                    {/* <img
                      alt="..."
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={require("./assets/img/theme/suchita.jpg")}
                      style={{ width: "200px", height: "200px" }}
                    /> */}
                    <div className="pt-4 text-center">
                      <h5 className="title">
                        <span className="d-block mb-1">Suchita Mistry</span>
                        <small className="h6 text-muted">Co-Founder</small>
                      </h5>
                    </div>
                  </div>
                </Col>
                <Col className="mb-5 mb-lg-0" lg="3" md="6">
                  <div className="px-4">
                    {/* <img
                      alt="..."
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={require("./assets/img/theme/hetvi.jpg")}
                      style={{ width: "200px", height: "200px" }}
                    /> */}
                    <div className="pt-4 text-center">
                      <h5 className="title">
                        <span className="d-block mb-1">Hetvi Patel</span>
                        <small className="h6 text-muted">Co-Founder</small>
                      </h5>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
            <br /> <br />
          </section>
          {/* <br /> <br /> */}
          {/* <section className="section section-lg pt-0">
            <Container>
              <Card className="bg-gradient-warning shadow-lg border-0">
                <div className="p-5">
                  <Row className="align-items-center">
                    <Col lg="8">
                      <h3 className="text-white">
                        We made website building easier for you.
                      </h3>
                      <p className="lead text-white mt-3">
                        I will be the leader of a company that ends up being
                        worth billions of dollars, because I got the answers. I
                        understand culture.
                      </p>
                    </Col>
                    <Col className="ml-lg-auto" lg="3">
                      <Button
                        block
                        className="btn-white"
                        color="default"
                        href="https://www.creative-tim.com/product/argon-design-system-react?ref=adsr-landing-page"
                        size="lg"
                      >
                        Download React
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Card>
            </Container>
          </section> */}
          {/* <section className="section section-lg bg-gradient-default">
            <Container className="pt-lg pb-300">
              <Row className="text-center justify-content-center">
                <Col lg="10">
                  <h2 className="display-3 text-white">Build something</h2>
                  <p className="lead text-white">
                    According to the National Oceanic and Atmospheric
                    Administration, Ted, Scambos, NSIDClead scentist, puts the
                    potentially record low maximum sea ice extent tihs year down
                    to low ice.
                  </p>
                </Col>
              </Row>
              <Row className="row-grid mt-5">
                <Col lg="4">
                  <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
                    <i className="ni ni-settings text-primary" />
                  </div>
                  <h5 className="text-white mt-3">Building tools</h5>
                  <p className="text-white mt-3">
                    Some quick example text to build on the card title and make
                    up the bulk of the card's content.
                  </p>
                </Col>
                <Col lg="4">
                  <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
                    <i className="ni ni-ruler-pencil text-primary" />
                  </div>
                  <h5 className="text-white mt-3">Grow your market</h5>
                  <p className="text-white mt-3">
                    Some quick example text to build on the card title and make
                    up the bulk of the card's content.
                  </p>
                </Col>
                <Col lg="4">
                  <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
                    <i className="ni ni-atom text-primary" />
                  </div>
                  <h5 className="text-white mt-3">Launch time</h5>
                  <p className="text-white mt-3">
                    Some quick example text to build on the card title and make
                    up the bulk of the card's content.
                  </p>
                </Col>
              </Row>
            </Container>
            <div className="separator separator-bottom separator-skew zindex-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
              >
                <polygon
                  className="fill-white"
                  points="2560 0 2560 100 0 100"
                />
              </svg>
            </div>
          </section> */}
          {/* <Download /> */}
          <br /> <br />
          <SimpleFooter></SimpleFooter>
        </main>
      </>
    );
  }
}

function reloadPage() {
  window.location.href = "/#/walkthrough"
  window.location.reload();
}

function aboutPage() {
  window.location.href = "/#/about"
}

function refreshPage() {
  window.location.href = "/#/walkthrough";
  window.location.reload();
}

export default Landing;